'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import useAccountQuery from '@/hooks/useAccountQuery';
import { getJWT } from '@/services/jwt';
import { accountHasRoles } from '@goodneighbor/roles';

export function usePartnerAccountRedirect() {
  const router = useRouter();
  const account = useAccountQuery({
    enabled: !!getJWT()
  });

  useEffect(() => {
    const accountData = account.data?.data;
    const hasOrganization = !!accountData?.organization;
    const hasDashboardAccess = accountHasRoles({
      account: account.data,
      operation: 'OR',
      requiredRoles: ['PARTNER_ACCOUNT_OWNER', 'PARTNER_MANAGER']
    });

    if (accountData && hasOrganization) {
      if (hasDashboardAccess) {
        router.push('/partner/dashboard');
      } else {
        router.push('/partner/dashboard/events');
      }
    }
  }, [account.data, router]);

  return account;
}
